import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'ok-angular-shared/auth';
import { SnackbarService } from 'ok-angular-shared/components';
import { tap } from 'rxjs/operators';

export const h401Interceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const authService = inject(AuthService);
  const snackbarService = inject(SnackbarService);
  const message = 'Din session er udløbet. Genindlæs venligst siden';

  return next(req).pipe(
    tap({
      error: err => {
        if (err instanceof HttpErrorResponse && err.status === 401) {
          const snackBarRef = snackbarService.error(message);

          snackBarRef?.afterDismissed().subscribe(info => {
            if (info.dismissedByAction === true) {
              authService.logout();
            }
          });
        }
      },
    })
  );
};
